import styled from '@emotion/native';
import React, { FC, useEffect, useRef, useState } from 'react';
import Text, { Props as TextProps } from './Text';



export type Props = Omit<TextProps, 'children'> & {
    /** The target number to count up to. */
    children: number;
    /** The total duration of the animation in milliseconds. */
    duration?: number;
    /** The number of frames per second for the animation. */
    framerate?: number;
};

const CounterUp: FC<Props> = ({ children, duration = 1000, framerate = 10, ...props }) => {

    const endValue = children;
    const [count, setCount] = useState(0);
    const animationFrameId = useRef<number>(0);

    useEffect(() => {
        let startTimestamp: number | null = null;
        let lastFrameTime = 0;
        const frameInterval = 1000 / framerate;

        const step = (timestamp: number) => {
            if (!startTimestamp) startTimestamp = timestamp;

            const elapsedSinceStart = timestamp - startTimestamp;
            const progress = Math.min(elapsedSinceStart / duration, 1);

            const elapsedSinceLastFrame = timestamp - lastFrameTime;

            if (elapsedSinceLastFrame >= frameInterval || progress === 1) {
                lastFrameTime = timestamp - (elapsedSinceLastFrame % frameInterval);
                const currentValue = progress * endValue;
                setCount(currentValue);
            }

            if (progress < 1) {
                animationFrameId.current = requestAnimationFrame(step);
            } else {
                setCount(endValue); // Ensure it ends on the exact value
            }
        };
        animationFrameId.current = requestAnimationFrame(step);

        return () => {
            if (animationFrameId.current) cancelAnimationFrame(animationFrameId.current);
        };
    }, [children, duration, framerate, endValue]);

    return (<Text {...props}>{count}</Text>);
}

export default CounterUp;


export const HeadingCounter = styled(CounterUp)`
    padding: 16px 48px;
    font-size: 24px;
    line-height: 36px;
    width: 348px;
`;